(function() {
    'use strict';

    angular
        .module('historyApp', ['corePRUGAGreatApp','updateClientApp', 'ui.select'])
        .run(run);

    run.$inject = ['stateHandler'];

    function run(stateHandler) {
        stateHandler.initialize();
    }
})();
